import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ReactComponent as RightArrow } from 'src/assets/images/icon/rightArr.svg';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

// Button component with right arrow.

const ArrowButton = (props) => {
  const { text, light, to, handleClick, href, downloadImg, isSubmitting } =
    props;

  const handleAs = () => {
    if (href) {
      return 'a';
    } else if (to) {
      return Link;
    } else {
      return 'button';
    }
  };

  const handleImage = () => {
    return <RightArrow />;
  };

  return (
    <Root
      onClick={handleClick}
      isSubmitting={isSubmitting}
      to={to}
      as={handleAs()}
      light={light}
      target={href && '_blank'}
      {...props}
    >
      <Wrapper light={light}>
        <p className="uppercase">{isSubmitting ? 'Submitting' : text}</p>
      </Wrapper>
      <Arrow light={light} downloadImg={downloadImg && 1}>
        {handleImage()}
        <div className="overlay" />
      </Arrow>
    </Root>
  );
};

ArrowButton.propTypes = {
  text: PropTypes.string,
  light: PropTypes.bool,
  downloadImg: PropTypes.bool,
  video: PropTypes.bool,
  to: PropTypes.string,
  handleClick: PropTypes.func,
};

ArrowButton.defaultProps = {
  handleClick: (f) => f,
};

const Root = styled.button`
  text-transform: uppercase;
  opacity: ${(props) => (props.isSubmitting ? 0.7 : 1)};
  display: flex;
  cursor: pointer;
  ${vw('height', 40, 40, 50)};
  @media ${media.desktop} {
    &:hover {
      .overlay {
        transform: scaleX(1);
      }
      svg path,
      svg rect {
        fill: ${(props) =>
          props.light ? props.theme.color.charcoal : props.theme.color.sand};
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  /* background-color: ${(props) =>
    props.light ? props.theme.color.sand : props.theme.color.charcoal}; */
  border: 1px solid #000};
  ${vw('padding-left', 20, 20, 30)}
  ${vw('padding-right', 20, 20, 30)}
  p {
    color: #000;
  }
`;

const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid #000};
  border-left: none;
  height: 100%;
  ${vw('width', 40)}

  svg {
    position: relative;
    z-index: 2;

    ${(props) => (props.downloadImg ? vw('width', 12) : vw('width', 40))}

    ${(props) => props.downloadImg && vw('height', 19)}

    path, rect {
      transition: ${({ theme }) => theme.transition};
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: -1px;
    width: calc(100% + 1px);
    height: 100%;
    background-color: ${(props) =>
      props.light ? props.theme.color.sand : props.theme.color.charcoal};
    transform: scaleX(0);
    transform-origin: left;
    transition: ${({ theme }) => theme.transition};
  }
`;

export default ArrowButton;
